module.exports = __webpack_public_path__ + "static/media/dsfd.abad1d88.JPG";